// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"36510224","108":"083368a6","363":"ec81b51a","367":"669aeee3","571":"d9713dc3","683":"9e317b48","892":"dc8140e2","904":"3e57c021","918":"e4d990a8","981":"86dfa29c"}[chunkId] + ".chunk.js";
};